import { Color } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { observer, Provider } from 'mobx-react';
import * as React from 'react';

import { ICameraStore } from '../components/camera/CameraStore';
import { IDiaryPageStore } from '../diary/DiaryPageStore';
import { IAddDrinkStore } from '../diary/drink/add/AddDrinkStore';
import { IAddMealStore } from '../diary/meal/add/AddMealStore';
import { IAddMeasurementStore } from '../diary/measurement/add/AddMeasurementStore';
import { IAddTrainingStore } from '../diary/training/add/AddTrainingStore';
import { IAddWaterStore } from '../diary/water/add/AddWaterStore';
import { LocaleStore, MobxIntlProvider } from '../intl';
import { IRouteStore } from '../RouteStore';
import { IUserStore } from '../user/UserStore';


import './App.css';
import AppContainer from './AppContainer';


export declare interface IAppStore {
  addTraining: IAddTrainingStore;
  addDrink: IAddDrinkStore;
  addMeal: IAddMealStore;
  addMeasurement: IAddMeasurementStore;
  addWater: IAddWaterStore;
  camera: ICameraStore;
  diaryPage: IDiaryPageStore;
  routes: IRouteStore;
  locale: LocaleStore;
  user: IUserStore;
}

declare interface IAppProps {
  store: IAppStore;
}

const secondary: Color = {
  50: '#f4e4eb',
  100: '#e3bdce',
  200: '#d091ad',
  300: '#bd648c',
  400: '#af4374',
  500: '#a1225b',
  600: '#991e53',
  700: '#8f1949',
  800: '#851440',
  900: '#740c2f',
  A100: '#ffa6c0',
  A200: '#ff739b',
  A400: '#ff4077',
  A700: '#ff2665'
};

const theme = createMuiTheme({
  palette: {
    primary: lightGreen,
    secondary,
    text: {
      primary: lightGreen[900]
    }
  },
  typography: {
    useNextVariants: true,
  }
})

@observer
export class App extends React.Component<IAppProps, {}> {

  public render() {
    return (
      <Provider {...this.props.store}>
        <MuiThemeProvider theme={theme}>
          <MobxIntlProvider locale={this.props.store.locale}>
            <AppContainer/>
          </MobxIntlProvider>
        </MuiThemeProvider>
      </Provider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/App.tsx